"use client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MedalIcon, MapIcon, PlaneIcon, GiftIcon } from "./Icons";
import { useTranslation } from "@/hooks/useLanguage";

const featureIcons = [<MedalIcon key="medal" />, <MapIcon key="map" />, <PlaneIcon key="plane" />, <GiftIcon key="gift" />];

export const HowItWorks = () => {
  const { t } = useTranslation();
  const featuresList = t("howItWorks.features");

  // Ensure featuresList is always an array to prevent runtime errors
  const safeFeaturesList = Array.isArray(featuresList) ? featuresList : [];

  return (
    <section id="howItWorks" className="container text-center py-24 sm:py-32">
      <h2 className="text-3xl md:text-4xl font-bold ">
        {t("howItWorks.title_1")}{" "}
        <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
          {t("common.pms")}{" "}
        </span>
        {t("howItWorks.title_2")}
      </h2>
      <p className="md:w-3/4 mx-auto mt-4 mb-8 text-xl text-muted-foreground">
        {t("howItWorks.description")}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {safeFeaturesList.map(({ title, description }, index) => (
          <Card key={title} className="bg-muted/50">
            <CardHeader>
              <CardTitle className="grid gap-4 place-items-center">
                {featureIcons[index]}
                {title}
              </CardTitle>
            </CardHeader>
            <CardContent>{description}</CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
